"use client";
import SectionPage from "@/components/common/section-page";

import { useNavigate } from "react-router-dom";
import {OnlyImageBgCard, PaveScaleCard} from "@/components/common/pave-scale-card";
import EspaceProTitleCard from "@/components/common/espace-pro-title-card";

export default function Home() {
  const navigate = useNavigate();

  return (
          <div className={"flex flex-col gap-6 pb-6 mb-8"}>

            <EspaceProTitleCard title={"Promotion"} description={"Côte d’Ivoire Tourisme Partenaire de réussite de l’industrie touristique."} />

              <SectionPage sectionType="lg">
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6 mb-6">
                      <PaveScaleCard title={"Guide de Voyage en Français"} buttonLabel={"Consulter"} className={"h-[400px]"} link="/pdf-viewer/GUIDE-DE-VOYAGE-CI.pdf" titleClassName={"font-playfair-display italic font-bold"} />
                      <OnlyImageBgCard imageSrc={"/images/espace-pro/promotion/1.jpg"} className={"h-[400px]"} />
                      <PaveScaleCard title={"Guide de Voyage en Anglais "} buttonLabel={"Consulter"} className={"h-[400px]"} link="/pdf-viewer/TRAVEL-GUIDE.pdf" titleClassName={"font-playfair-display italic font-bold"} />
                      <PaveScaleCard title={"Forums & Séminaires "} buttonLabel={"Consulter"} className={"h-[400px]"} link="/espace-pro/promotion/forums-seminaires" titleClassName={"font-playfair-display italic font-bold"} />
                      <OnlyImageBgCard imageSrc={"/images/espace-pro/promotion/2.jpg"} className={"h-[400px]"} />
                  </div>
              </SectionPage>

        </div>
  );
}
